// note: we dont use the nuxt config, as it only applies at build time.
// rather, we must sent the domain dynamically.
export default defineNuxtPlugin(() => {
  const domain = window.location.hostname

  const script = document.createElement('script')
  script.setAttribute('defer', '')
  script.setAttribute('data-domain', domain)
  script.src = 'https://analytics.lflgroup.io/js/script.js'
  document.head.appendChild(script)
})
